import styled from "styled-components"

const ResultsCard = ({ badge1, score1, badge2, score2 }) => {
  return (
    <Wrapper>
      <Container>
        <Img src={badge1}></Img>
        <Text>
          {score1} - {score2}
        </Text>
        <Img src={badge2}></Img>
      </Container>
    </Wrapper>
  )
}

export default ResultsCard

const Wrapper = styled.div`
  padding: 0.2rem;
  width: 100%;
`
const Container = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 0.4rem;
  box-shadow: 0 0 4px 1px #00eaff;
  @media (max-width: 1200px) {
    padding: 0.2rem;
  }
  border-radius: 12px;
  border: 2px solid #5fa8e6;
  background: linear-gradient(120deg, #23263a 60%, #1a1c28 100%);
`
const Img = styled.img`
  height: 35px;
  width: 35px;
`
const Text = styled.p`
  margin: 0;
  padding: 0;
`
